import BaseProtable from "@/components/BaseProTable";
import { PrimaryButton } from "@/components/ui/buttons/PrimaryButton";
import CommonModal from "@/components/ui/CommonModal";
import { notifyWarning } from "@/utils/notification";
import { type TableProps } from "antd";
import { useState } from "react";
import { usePageTable } from "@/hooks/baseProTable/usePageTable";
import {
  SrmSupplierAdmissionApplicationPage,
  SrmSupplierAdmissionApplicationPageDTO,
} from "@/types/apis";
import { useTranslation } from "react-i18next";
import { getAdmissionApplicationPage } from "@/apis/supplier";
import { createTableColumns } from "./table-columns";

type SelectItem = SrmSupplierAdmissionApplicationPage;

type Props = {
  open: boolean;
  onOk: (selectedRows: SelectItem[]) => void;
  onClose: () => void;
  /** 选择模式，默认多选 */
  selectionMode?: "multiple" | "single";
};

const AdmissionApplicationSelectModal: React.FC<Props> = ({
  open,
  onOk,
  onClose,
  selectionMode = "single",
}) => {
  const { t } = useTranslation("supplierProfile");
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [selectedRows, setSelectedRows] = useState<SelectItem[]>([]);
  const [params, setParams] = useState<SrmSupplierAdmissionApplicationPageDTO>(
    {},
  );

  const { actionRef, fetchDatasource, columns, formRef } = usePageTable<
    SrmSupplierAdmissionApplicationPage,
    SrmSupplierAdmissionApplicationPageDTO
  >({
    fetchFn: getAdmissionApplicationPage,
    columns: createTableColumns(t),
  });

  const rowSelection: TableProps<SelectItem>["rowSelection"] = {
    type: selectionMode === "single" ? "radio" : "checkbox",
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      if (selectionMode === "single") {
        setSelectedRowKeys(selectedRowKeys.slice(0, 1));
        setSelectedRows(selectedRows.slice(0, 1));
        return;
      }
      setSelectedRowKeys(selectedRowKeys);
      setSelectedRows(selectedRows);
    },
  };

  const handleOk = () => {
    if (selectedRows.length === 0) {
      notifyWarning("请选择准入申请");
      return;
    }
    onOk?.(selectedRows);
    handleClose();
  };

  const handleClose = () => {
    setSelectedRowKeys([]);
    setSelectedRows([]);
    setParams({});
    onClose();
  };

  const footer = () => (
    <div style={{ textAlign: "center" }}>
      <PrimaryButton onClick={handleOk}>确定</PrimaryButton>
    </div>
  );

  return (
    <CommonModal
      title="选择准入申请"
      open={open}
      onCancel={handleClose}
      width={1200}
      style={{ top: 20 }}
      footer={footer}
    >
      <BaseProtable<SelectItem>
        headerTitle={null}
        actionRef={actionRef}
        formRef={formRef}
        columns={columns}
        rowSelection={rowSelection}
        rowKey="id"
        bordered
        request={fetchDatasource}
        params={params}
        search={{
          labelWidth: "auto",
          span: 6,
        }}
        onSubmit={(values) => setParams({ ...values })}
      />
    </CommonModal>
  );
};

export default AdmissionApplicationSelectModal;
